// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style-module_wrapper_PWS_MXYM0KbXr9Us0LVy > * + * {
  margin-left: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/components/ButtonsWrapper/style.module.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;AACF","sourcesContent":[".wrapper > *+* {\n  margin-left: 1rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `style-module_wrapper_PWS_MXYM0KbXr9Us0LVy`
};
export default ___CSS_LOADER_EXPORT___;
